<div [ngStyle]="{'width': width, 'height.px': height}" class="skeleton" aria-busy="true" aria-live="polite">
  <div class="sk-row">
    <div class="sk-avatar sk-shimmer"></div>
    <div class="sk-col">
      <div class="sk-line sk-shimmer" style="width: 60%"></div>
      <div class="sk-line sk-shimmer" style="width: 90%"></div>
    </div>
  </div>

  <div class="sk-card sk-shimmer"></div>

  <div class="sk-row">
    <div class="sk-line sk-shimmer" style="width: 95%"></div>
    <div class="sk-line sk-shimmer" style="width: 80%"></div>
    <div class="sk-line sk-shimmer" style="width: 70%"></div>
  </div>
</div>
